import { RxJsonSchema, RxDocument } from 'rxdb';
import { ScoutTask, TaskType } from '../models';
import { TaskAssignmentsSchemaObjectDef, TaskScheduleSchemaObjectDef, TaskStatusGroupSchemaObjectDef } from './task-schema';

export const scoutTaskMethods = {
    getPathById(id:string){
        return this.scoutPaths?.find(p=>p.id == id)
    }
}


export type ScoutTaskDoc = RxDocument<ScoutTask,typeof scoutTaskMethods>

export const scoutTaskSchema: RxJsonSchema<ScoutTask> = {
    title: 'scout task schema',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        _id: {
            type: 'string',
            primary: true,
            default: ''
        },
        assignedUserId: {
            type: 'string'
        },
        type: {
            type: 'string',
            default: TaskType.SCOUT
        },
        stage: {
            type: 'string'
        },
        buildingId: {
            type: 'string'
        },
        groupingfield: {
            type:[ 'string','null']
        },
        schedule: TaskScheduleSchemaObjectDef,
        assignments: TaskAssignmentsSchemaObjectDef,
        status: TaskStatusGroupSchemaObjectDef,
        scoutPaths: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    pathNumber: {
                        type: ['number', 'null']
                    },
                    description: {
                        type: 'string'
                    },
                    modifiedDate: {
                        type: ['string','null']
                    },
                    userId: { type: 'string' },
                    scoutPoints: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                id: {
                                    type: 'string'
                                },
                                parentId: {
                                    type: ['string','null']
                                },
                                pointId: {
                                    type: 'string'
                                },
                                type: {
                                    type: 'string'
                                },
                                horizontalDistance: {
                                    type: 'number'
                                },
                                bearing: {
                                    type: 'number'
                                },
                                heightOffset: {
                                    type: 'number'
                                },
                                latitude: {
                                    type: 'number'
                                },
                                longitude: {
                                    type: 'number'
                                },
                                refData : {
                                    type: [ 'object', 'null'],
                                },
                                envData : {
                                    type: [ 'object', 'null' ]
                                },
                                exPointId : {
                                    type: [ 'string', 'null' ]
                                },
                                horizontalError: {
                                    type: [ 'object', 'number', 'null'], // old way used number, new version is an object
                                    properties: {
                                        implConstant: { type: 'number'},
                                        implEstimate: { type: 'number'},
                                        segmentEstimate: { type: 'number'},
                                        cumulativeEstimate: { type: 'number'},

                                        derivedFromExternalWall: { type: 'boolean'},
                                        externalWallAngleConstant: { type: 'number'},
                                        measuredAngleConstant: { type: 'number'},
                                        externalWallAngleEstimate: { type: 'number'},
                                        measuredAngleEstimate: { type: 'number'}                      }
                                    },
                                veriticalError: {
                                    type: [ 'object', 'number', 'null'],
                                    properties: {
                                        implConstant: { type: 'number'},
                                        implEstimate: { type: 'number'},
                                        segmentEstimate: { type: 'number'},
                                        cumulativeEstimate: { type: 'number'},

                                        unlevelFloor: { type: 'boolean'},
                                        floorVarianceConstant: { type: 'number'},
                                        unlevelFloorConstant: { type: 'number'},
                                        floorVarianceEstimate: { type: 'number'},
                                        unlevelFloorEstimate: { type: 'number'}
                                    }
                                },
                                diabled: {
                                    type: 'boolean'
                                }
                            }
                        }
                    },
                    comments: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                id: { type: 'string'},
                                text: { type: 'string' },
                                archived: { type: 'boolean' },
                                timestamp: { type: 'string' },
                                userId: { type: 'string' }
                            }
                        }
                    },
                    overlay: {
                        type: [ 'object', 'null' ]
                    },
                    statusId: {
                        type: 'number'
                    }
                }
            }
        }
    },
    required: ['_id'],
    indexes: ['assignedUserId','type', 'buildingId']
};
